import React from 'react';
import { Modal, ListGroup, ListGroupItem } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { SearchLavutogoLocations } from '../../api/searchForAddress';
import { connect } from 'react-redux';
import { LoadingList } from '../common/Loading';
import { initSocket } from '../../socket/index';
import {
  setLavutogoRefereName,
  setListOfRestaurant,
} from '../dashboard/actions';
import FontAwesome from 'react-fontawesome';
import { API_ERROR } from '../../lib/helper';
import { get } from 'lodash';
import defaultMsg from '../../translations/lang/en-US.json';

class DuplicatLavuToGoName extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      showList: false,
    };
    this.showRestaurentList = this.showRestaurentList.bind(this);
    this.hideRestaurentList = this.hideRestaurentList.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  showRestaurentList() {
    this.setState({
      showList: true,
      loading: false,
    });
  }

  hideRestaurentList() {
    this.setState({
      showList: false,
      loading: false,
    });
  }

  handleClick(e) {
    this.setState({
      showList: false,
    });
    this.props.handleClick(e);
  }

  isSearchRequired() {
    return (
      this.props.refereLavuTogoDataName === true ||
      this.props.lavuTogoName !== this.props.referLavuTogoName
    );
  }

  componentWillMount() {
    if (this.isSearchRequired()) {
      const { 
        lavuTogoName, 
        jwt,
        tokenId,
        dispatch,
        merchantDetails,
        hideList,
        closeSigin,
        closeInitialSigin
      } = this.props;

      dispatch(setListOfRestaurant([]));
      SearchLavutogoLocations({
        lavuTogoName,
        jwt,
        tokenId,
      })
        .catch(error => {
          dispatch(setLavutogoRefereName(false));
          API_ERROR(error);
        })
        .then(result => {
          let addressList = get(result, 'data.DataResponse', []);
          dispatch(setListOfRestaurant(addressList));
          const manageItemAvailability = get(merchantDetails, 'manage_item_availability', false);
          if ( addressList.length === 1 && 
               manageItemAvailability ) {
            const address = addressList[0];
            const encdataname = get(address, 'enc_dataname');
            initSocket(encdataname);
          }
          if (addressList.length <= 1) {
            dispatch(setLavutogoRefereName(false));
          } else {
            if (!hideList) {
              closeSigin();
              closeInitialSigin();
            }
            this.setState({
              loading: false,
            });
          }
        });
    } else {
      this.setState({
        loading: false,
      });
    }
  }

  render() {
    const isSerachRequired = this.isSearchRequired();
    const addressList = get(this, 'props.addressList', false);

    const showRestaurantList =
      (isSerachRequired &&
        addressList !== false &&
        !this.state.loading &&
        !this.props.hideList) ||
      this.state.showList
        ? true
        : false;

    const showRestaurentButton =
      addressList !== false &&
      (!isSerachRequired || this.props.hideList) &&
      !this.state.loading
        ? true
        : false;
    return (
      <div className="scroll-modal">
        {showRestaurantList ? (
          <Modal show={true} role="dialog" onHide={this.hideRestaurentList}>
            <Modal.Header closeButton={!this.isSearchRequired()}>
              <h4 className="modal-title olo-client-theme-color font-medium text-center">
                <FormattedMessage
                  id="duplicateLavuTogoNameHeader"
                  defaultMessage={defaultMsg.duplicateLavuTogoNameHeader}
                />
              </h4>
            </Modal.Header>
            <Modal.Body>
              {this.state.loading ? (
                <LoadingList />
              ) : (
                <ListRestaurant
                  list={this.props.addressList}
                  lavuTogoName={this.props.lavuTogoName}
                  handleClick={this.handleClick}
                />
              )}
            </Modal.Body>
          </Modal>
        ) : (
          <div className="bottom-show-modal">
            {showRestaurentButton ? (
              <button
                type="button"
                onClick={this.showRestaurentList}
                className="btn btn-default olo-client-theme-color"
                title="Find Restaurant"
              >
                <FontAwesome name="map-marker" />
              </button>
            ) : null}
          </div>
        )}
      </div>
    );
  }
}

const ListRestaurant = props => {
  return (
    <ListGroup>
      {props.list.map((restaurant, key) => {
        return (
          <RestaurantDetails
            handleClick={e => props.handleClick(e)}
            key={key}
            data={restaurant}
            lavuTogoName={props.lavuTogoName}
          />
        );
      })}
    </ListGroup>
  );
};

const RestaurantDetails = props => {
  const { title, address, city, state, country, zip, dataname } = props.data;
  return (
    <ListGroupItem
      className="font-medium"
      onClick={e => props.handleClick(dataname, e)}
    >
      <h4 className={`olo-client-theme-color font-medium`}> {`${title}`}</h4>
      <div className="font-small">
        {`${address},${city} ${state} ${country}-${zip}`}{' '}
      </div>
    </ListGroupItem>
  );
};

function mapStateToProps(state) {
  return {
    addressList: state.dashboard.listOfRestaurant,
    refereLavuTogoDataName: state.dashboard.refereLavuTogoDataName,
    referLavuTogoName: state.dashboard.referLavuTogoName,
    tokenId: state.auth.tokenId,
    jwt: state.auth.jwt,
    hideList: state.dashboard.hideDuplicateLavuToGoRestuarantList,
    merchantDetails: state.dashboard.merchantDetails,
  };
}
export default connect(mapStateToProps)(DuplicatLavuToGoName);



// WEBPACK FOOTER //
// ./src/views/modals/DuplicatLavuToGoName.jsx